module.exports = {
  name: "tipModal",
  data() {
    return {
      showModal: false,
      issuer: {}
    };
  },
  props: {
    unitName: {
      type: String
    },
    unitCode: {
      type: String
    }
  },
  methods: {
    close() {
      this.showModal = false;
      this.$emit("confirm", this.issuer, this.unitCode);
    },
    nextStep() {
      this.showModal = false;
      this.$emit("cancel");
    },
    open(issuer) {
      this.showModal = true;
      this.issuer = issuer;
    }
  }
};